const SIZE_SEGMENT = /\/(?:large|medium|small|tiny)\//;
const ORIGINAL_SEGMENT = '/original/';

const originalUrl = (url: string) => url.replace(SIZE_SEGMENT, ORIGINAL_SEGMENT);
const resizedUrl = (url: string) => url.replace(ORIGINAL_SEGMENT, '/large/');

const prepareImage = (image: HTMLImageElement) => {
  const source = image.getAttribute('src');
  if (!source || (!source.includes('/original/') && !SIZE_SEGMENT.test(source))) return;
  if (image.dataset.wfAsyncFallback === 'true' && source.includes('/original/')) return;
  if (image.dataset.wfAsyncImageSource === source) return;

  const original = source.includes('/original/') ? source : originalUrl(source);
  const resized = source.includes('/original/') ? resizedUrl(source) : source;
  image.dataset.wfAsyncImageSource = source;
  image.dataset.wfOriginalSrc = original;
  image.dataset.wfResizedSrc = resized;

  image.onerror = () => {
    image.dataset.wfAsyncFallback = 'true';
    if (image.src !== original) image.src = original;
  };

  if (source.includes('/original/') && image.src !== resized) image.src = resized;
};

export default defineNuxtPlugin(() => {
  if (import.meta.server) return;

  const scan = (root: ParentNode | HTMLImageElement = document) => {
    if (root instanceof HTMLImageElement) prepareImage(root);
    if (!(root instanceof HTMLImageElement)) {
      root.querySelectorAll('img').forEach((image) => prepareImage(image));
    }
  };

  scan();
  new MutationObserver((records) => {
    records.forEach((record) => {
      record.addedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) scan(node as ParentNode);
      });
      if (record.type === 'attributes' && record.target instanceof HTMLImageElement) {
        prepareImage(record.target);
      }
    });
  }).observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['src'],
  });
});
